export const Footer = () => {
  return (
    <div id="footer">
      <p>
      <br />Developed by Marcus Ma in association with Georgia Tech.
      
      <br /> Based on the amazing tool, <a target="_blank" rel='noreferrer' href="https://clox.ling.washington.edu/"> CLOx, </a>
      developed at the<br/> University of Washington Sociolinguistics Laboratory.
      <br />Powered by Microsoft Azure Cognitive Services.
    <br /> Logo designed by <a target="_blank" rel='noreferrer' href="https://andywz.com">Andy Zheng</a>.
      
      </p>
    </div>
  )
}
